import {API_URL, apiPost} from '../api'

export interface ICreatePost {
    title?: string
    content: string
    channel: string
    visibility: number
    images?: string[]
    type?: string
    categories?: string[]
    thumbnail?: string
    important_at?: number
}

export const createPostApi = async (data: ICreatePost) => {
    return await apiPost(API_URL, 'post', data)
}
